import React, { useEffect, useRef } from "react";
import "./Experience.css";

const EXPERIENCE = [
  {
    period: "Jul 2025 - Present",
    company: "Digital Future of Education (Frisome)",
    location: "Bengaluru, India",
    role: "Full Stack Engineer",
    badge: "Current",
    bullets: [
      "Optimized MySQL queries and implemented in-memory response caching for sales report APIs - reduced response latency by 60% for complex aggregation queries across large historical date ranges",
      "Built a unified Angular workflow for menu item creation, enabling users to configure add-ons, omissions, and variation groups without leaving the page",
      "Mentored an engineering intern and introduced structured code review practices - reduced issues identified during QA from 20+ to ~10-15 per feature",
    ],
  },
  {
    period: "Jul 2024 - Jul 2025",
    company: "Pepperfry Limited",
    location: "Bengaluru, India",
    role: "Software Engineer I",
    bullets: [
      "Built Angular-based protection plan upsell interface from Figma specs using Angular Material - increased attach rates by 5% on a high-traffic e-commerce platform",
      "Migrated a legacy PHP complaint portal to Angular and Node.js - enabled image and video uploads for complaint evidence, reducing customer support effort",
      "Developed a configurable promotional banner system deployed across home, product, order, and checkout pages",
    ],
  },
  {
    period: "Feb 2024 - May 2024",
    company: "Impelsys",
    location: "Bengaluru, India",
    role: "Software Engineer Intern",
    bullets: [
      "Built a React.js chatbot integrated with AWS Lex and Lambda - achieved ~72% intent accuracy across 100+ internal test queries for healthcare workflows",
    ],
  },
];

const Experience = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.querySelectorAll(".fade-up").forEach((el, i) => {
            if (entry.isIntersecting) {
              setTimeout(() => el.classList.add("visible"), i * 120);
            }
          });
        });
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="experience" className="experience-section" ref={sectionRef}>
      <div className="section-inner">
        <div className="section-label fade-up">02 - Experience</div>
        <h2 className="section-title fade-up">Where I've shipped</h2>

        <div className="exp-list">
          {EXPERIENCE.map((exp, i) => (
            <div className="exp-item fade-up" key={i}>
              <div className="exp-meta">
                <div className="exp-period">{exp.period}</div>
                <div className="exp-company">{exp.company}</div>
                <div className="exp-location">{exp.location}</div>
                {exp.badge && <div className="exp-badge">{exp.badge}</div>}
              </div>
              <div>
                <div className="exp-role">{exp.role}</div>
                <div className="exp-bullets">
                  {exp.bullets.map((b, j) => (
                    <div className="exp-bullet" key={j}>
                      {b}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
